var qs = new URLSearchParams((document.location.search || "?").substring(1));

var editor = null;

var dshd_runit = function(){};

var order_id = qs.get("order") || "123";

function designerLoad() {

  var product_titles = qs.getAll("productname");
  var product_skus = qs.getAll("productSKU");

  var template_names = {
    "odp": "Disc Print",
    "2odp": "Disc Prints",
    "eco": "Atomic eco-pack™",
    "jck": "Jacket Side opening",
    "wl": "Wallet Lite™",
    "DIY": "Atomic DIY Pack™",
    "dl4p": "Digipack Lite™ 4p",
    "dl4pp": "Digipack Lite™ 4pp",
    "dl6p": "Digipack Lite™ 6p",
    "dl4p2d": "Digipack Lite™ 4p2d",
    "sw4p": "Standard Wallet 4p",
    "sw4p2p1d": "Standard Wallet 4p2p",
    "sw4p2p2d": "Standard Wallet 4p2p",
    "sw6p": "Standard Wallet 6p",
    "sw6p2p1d": "Standard Wallet 6p2p",
    "sw6p2p2d": "Standard Wallet 6p2p",
    "sd4p": "Standard Digipack 4p",
    "sd4ptp": "Standard Digipack 4ptp",
    "sd4psp": "Standard Digipack 4psp",
    "sd6p": "Standard Digipack 6p",
    "sd6ptp": "Standard Digipack 6ptp",
    "sd6psp": "Standard Digipack 6psp",
    "dvdw": "DVD wrap",
    "i2p": "Inserts 2p",
    "i4p": "Inserts 4p",
    "i6p": "Inserts 6p",
    "i8p": "Inserts 8p",
    "agj": "Vinyl Jacket",
    "aevA": "Eco-Vinyl Outside",
    "adpt": "11\"x17\" Trimmed Poster",
    "adput": "11\"x17\" Untrimmed Poster",
    "s2x2": "Stickers s2x2",
    "s2x3": "Stickers s2x3",
    "s2x35": "Stickers s2x35",
    "s2x4": "Stickers s2x4",
    "s2x8": "Stickers s2x8",
    "s25x35": "Stickers s25x35",
    "s25r": "Stickers s25r",
    "s2o": "Stickers s2o",
    "s3x4": "Stickers s3x4",
    "s3x5": "Stickers s3x5",
    "s35x35": "Stickers s35x35",
    "s35x85": "Stickers s35x85",
    "s4x4": "Stickers s4x4",
    "s4x6": "Stickers s4x6",
    "agl": "Groove Labels",
    "aevB": "Eco-Vinyl Inside",
    "agiA": "Vinyl Insert A",
    "aeviA": "Eco-Vinyl Insert Front",
    "agiB": "Vinyl Insert B",
    "aeviB": "Eco-Vinyl Insert Back",
    "aevl": "Labels",
    "43102": "43102Templates",
    "49585": "49585Templates"
  };

  var sku_templates = {
    "odp": ["odp"],
    "eco": ["eco","odp"],
    "jck": ["jck","odp"],
    "wl": ["wl","odp"],
    "dl4p": ["dl4p","odp"],
    "dl4pp": ["dl4pp","odp"],
    "dl6p": ["dl6p","odp"],
    "dl4p2d": ["dl4p2d","2odp"],
    "sw4p": ["na"],
    "sw4p2p1d": ["na"],
    "sw4p2p2d": ["na"],
    "sw6p": ["na"],
    "sw6p2p1d": ["na"],
    "sw6p2p2d": ["na"],
    "sd4p": ["na"],
    "sd4ptp": ["na"],
    "sd4psp": ["na"],
    "sd6p": ["na"],
    "sd6ptp": ["na"],
    "sd6psp": ["na"],
    "dvdw": ["na"],
    "ag": ["na"],
    "agi": ["na"],
    "aev": ["na"],
    "i2p": ["i2p"],
    "i4p": ["i4p"],
    "i6p": ["i6p"],
    "i8p": ["i8p"],
    "adpt": ["adpt"],
    "adput": ["adput"],
    "s2x2": ["na"],
    "s2x3": ["na"],
    "s2x35": ["na"],
    "s2x4": ["na"],
    "s2x8": ["na"],
    "s25x35": ["na"],
    "s25r": ["na"],
    "s2o": ["na"],
    "s3x4": ["na"],
    "s3x5": ["na"],
    "s35x35": ["na"],
    "s35x85": ["na"],
    "s4x4": ["na"],
    "s4x6": ["na"],
    "DIY": ["na"],
    "43102": ["TEMP", "TEMP2", "TEMP3"],
    "49585": ["49585DL6", "49585ODP"]
  };

  var sku_info = [];

  for (var i = 0; i < product_skus.length; i++) {
    var sku = product_skus[i];
    sku_info.push({
      sku: sku,
      product_title: product_titles[i],
      template_codes: sku_templates[sku] || []
    });
  }

  console.log(JSON.stringify(sku_info, null, 2));

  var template_codes = [];
  for (var s in sku_info) {
    template_codes = template_codes.concat(sku_info[s].template_codes);
  }

  var template_project_mapping = {};
  var current_project_id = null;
  var image_warnings_shown = {};

  // ── Build tabs and wire up "ALL DONE" button once DOM is ready ──────────────
  function buildTabs() {
    var tab_container = document.getElementById('template_tabs');
    if (!tab_container) return;

    for (var s = sku_info.length - 1; s >= 0; s--) {
      var skuObj = sku_info[s];
      for (var t = skuObj.template_codes.length - 1; t >= 0; t--) {
        var tc = skuObj.template_codes[t];
        var btn = document.createElement('button');
        btn.className = 'tablinks button button-secondary';
        btn.textContent = template_names[tc] || (t + 1);
        btn.setAttribute('data-tc', tc);
        if (s === 0 && t === 0) btn.classList.add('active');

        // Use an IIFE to capture tc correctly in the closure
        (function(capturedTc, capturedBtn) {
          capturedBtn.addEventListener('click', function() {
            tab_container.querySelectorAll('button.tablinks').forEach(function(b) {
              b.classList.remove('active');
            });
            capturedBtn.classList.add('active');
            if (
              editor !== null &&
              template_project_mapping[capturedTc] &&
              current_project_id !== template_project_mapping[capturedTc]
            ) {
              current_project_id = template_project_mapping[capturedTc];
              editor.changeProject(current_project_id);
            }
          });
        })(tc, btn);

        // Prepend so the loop-in-reverse produces correct left-to-right order
        tab_container.insertBefore(btn, tab_container.firstChild);
      }
    }

    var finishedBtn = document.getElementById('finished_projects');
    if (finishedBtn) {
      finishedBtn.addEventListener('click', function() {
        var project_ids = [];
        for (var key in template_project_mapping) {
          project_ids.push(template_project_mapping[key]);
        }
        location.href =
          '/pages/designer-proofs?order=' + order_id +
          '&project_id=' + project_ids.join('&project_id=');
      });
    }
  }

  // ── Wire up popup close button ───────────────────────────────────────────────
  function bindPopupClose() {
    var closeBtn = document.querySelector('.popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        document.querySelector('.popup').style.display = 'none';
        document.querySelector('.popup-overlay').style.display = 'none';
      });
    }
  }

  // Run tab-building and popup wiring after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      buildTabs();
      bindPopupClose();
    });
  } else {
    buildTabs();
    bindPopupClose();
  }

  // ── Main DesignHuddle logic (runs after lib.js loads) ────────────────────────
  dshd_runit = function() {
    if (!template_codes.length) {
      var designerEl = document.getElementById('Designer');
      if (designerEl) {
        var h3 = designerEl.querySelector('h3');
        if (h3) h3.textContent = 'No Products Found';
      }
      return;
    }

    DSHDEditorLib.getProjects({
      limit: 100,
      page: 1,
      source_template_codes: template_codes
    }, function(error, data) {
      if (error) {
        console.log(error);
      } else if (data.total) {
        for (var p in data.items) {
          var project = data.items[p];
          if (
            project.project_title.indexOf(order_id) === 0 &&
            !template_project_mapping[project.source_template.source_template_code]
          ) {
            template_project_mapping[project.source_template.source_template_code] =
              project.project_id;
          }
        }
      }

      var createEditor = function(project_id) {
        current_project_id = project_id;
        DSHDEditorLib.insert('Designer', { project_id: project_id }, function(err, e) {
          editor = e;

          // Remove the "Loading..." h3 once the editor is inserted
          var h3 = document.querySelector('#Designer h3');
          if (h3) h3.parentNode.removeChild(h3);

          var init = false;
          e.handleProjectData(function() {
            if (!init) {
              init = true;
              e.handleProjectDataChange(function() {
                e.getProjectData({ simple: false }, function(err, data) {
                  if (err) return;
                  for (var pg in data.pages) {
                    var page = data.pages[pg];
                    var dpi_multiplier = 1;
                    if (page.dimensions.unit_type_id === 'in') {
                      dpi_multiplier = 300;
                    } else if (page.dimensions.unit_type_id === 'mm') {
                      dpi_multiplier = 300 / 25.4;
                    }
                    for (var el in page.elements) {
                      var element = page.elements[el];
                      if (element.type === 'image') {
                        if ((element.width * dpi_multiplier) > element.source_width) {
                          if (!image_warnings_shown[el]) {
                            image_warnings_shown[el] = true;
                            var popup = document.querySelector('.popup');
                            var overlay = document.querySelector('.popup-overlay');
                            if (popup) popup.style.display = 'block';
                            if (overlay) overlay.style.display = 'flex';
                          }
                        } else {
                          delete image_warnings_shown[el];
                        }
                      }
                    }
                  }
                });
              });
            }
          });
        });
      };

      for (var t = 0; t < template_codes.length; t++) {
        // Use IIFE to capture t correctly
        (function(idx) {
          var template_code = template_codes[idx];
          var project_id = template_project_mapping[template_code];

          if (project_id) {
            if (idx === 0) createEditor(project_id);
          } else {
            DSHDEditorLib.createProject({
              template_code: template_code,
              project_title: order_id + ' - ' + template_code
            }, function(error, data) {
              if (error) {
                console.log(error);
              } else {
                var new_project_id = data.project_id;
                template_project_mapping[template_code] = new_project_id;
                if (idx === 0) createEditor(new_project_id);
              }
            });
          }
        })(t);
      }
    });
  };

} // end designerLoad()


function proofsLoad() {
  var project_ids = qs.getAll("project_id");
  if (!project_ids.length) {
    console.log("No Projects");
    return;
  }

  var project_titles = {};
  var domain = "https://atomicdisc.designhuddle.com";

  var getProject = function(token, project_id, callback) {
    fetch(domain + "/api/projects/" + project_id, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      headers: { "authorization": "Bearer " + token }
    }).then(function(response) {
      response.json().then(function(json) {
        if (response.ok && json.success && json.data) {
          callback(null, json.data);
        } else {
          callback(new Error("Get Project Error"));
        }
      });
    });
  };

  var startExport = function(token, project_id, params, callback) {
    fetch(domain + "/api/projects/" + project_id + "/export", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: {
        "authorization": "Bearer " + token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    }).then(function(response) {
      response.json().then(function(json) {
        if (response.ok && json.success && json.data) {
          callback(null, json.data.job_id);
        } else {
          callback(new Error("Export Error"));
        }
      });
    });
  };

  var pollExportJob = function(token, project_id, job_id, callback, attempt) {
    fetch(domain + "/api/projects/" + project_id + "/export/jobs/" + job_id, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      headers: { "authorization": "Bearer " + token }
    }).then(function(response) {
      response.json().then(function(json) {
        if (!response.ok || !json.success || !json.data ||
            (!json.data.completed && (attempt || 1) < 10)) {
          setTimeout(function() {
            pollExportJob(token, project_id, job_id, callback, (attempt || 1) + 1);
          }, (attempt || 1) * 1500);
        } else {
          if (json.data.completed) {
            callback(null, json.data.download_url);
          } else {
            callback(new Error("Export Job Timeout"));
          }
        }
      });
    });
  };

  var setAsPending = function(token, project_id, callback) {
    fetch(domain + "/api/projects/" + project_id + "/approval-submission", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: {
        "authorization": "Bearer " + token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({})
    }).then(function(response) {
      response.json().then(function(json) {
        if (response.ok && json.success) {
          callback(null);
        } else {
          callback(new Error("Set As Pending Error"));
        }
      });
    });
  };

  dshd_runit = function() {
    DSHDEditorLib.getGuestAccessToken({}, function(err, access_token) {
      if (err) {
        console.log(err);
        return;
      }

      var project_previews = {};
      var counter = project_ids.length;

      for (var i = 0; i < project_ids.length; i++) {
        (function(idx) {
          var project_id = project_ids[idx];
          getProject(access_token, project_id, function(oerr, project_data) {
            if (oerr) { console.log(oerr); return; }

            project_titles[project_id] = project_data.project_title;
            var page_count = project_data.pages.length;
            counter += (page_count - 1);

            for (var p = 0; p < page_count; p++) {
              (function(pageIdx) {
                var project_page = project_data.pages[pageIdx];
                var export_params = {
                  page_id: project_page.page_id,
                  format: "png",
                  filename: "preview",
                  dpi: 300,
                  render_excluded_elements: true
                };

                startExport(access_token, project_id, export_params, function(ierr, job_id) {
                  if (ierr) { console.log(ierr); return; }

                  pollExportJob(access_token, project_id, job_id, function(iierr, image_url) {
                    if (iierr) { console.log(iierr); return; }

                    project_previews[idx] = project_previews[idx] || [];
                    project_previews[idx][pageIdx] = image_url;

                    if (--counter === 0) {
                      // All exports done — build the preview gallery
                      var container = document.getElementById('project_previews');
                      if (!container) return;

                     var ul = document.createElement('ul');
                        ul.style.listStyle = 'none';
                        ul.style.padding = '0';
                        ul.style.margin = '0';

                        for (var j = 0; j < project_ids.length; j++) {
                        var urls = project_previews[j];
                        if (!urls) continue;
                        for (var k = 0; k < urls.length; k++) {
                            var li = document.createElement('li');
                            li.style.display = 'block';
                            li.style.marginBottom = '12px';
                            var a = document.createElement('a');
                            a.href = urls[k];
                            a.className = 'glightbox';
                            a.target = '_blank';
                            a.setAttribute('data-type', 'image');
                            a.rel = 'noopener noreferrer';
                            a.type = 'image/png';
                            var img = document.createElement('img');
                            img.src = urls[k];
                            img.style.maxWidth = '100%';
                            img.style.display = 'block';
                            a.appendChild(img);
                            li.appendChild(a);
                            ul.appendChild(li);
                        }
                        }

                      container.innerHTML = '';
                      container.appendChild(ul);
                      GLightbox({ selector: '.glightbox' });

                      // If you later want to restore a lightbox, add it here.
                      // magnific-popup required jQuery so it's been removed.
                      // A plain new-tab link works fine as a fallback.

                    } else {
                      // Preload remaining images in background
                      var preload = new Image();
                      preload.src = image_url;
                    }
                  });
                });
              })(p);
            }
          });
        })(i);
      }
    });

    window.addEventListener('PaperformSubmission', function() {
      DSHDEditorLib.getGuestAccessToken({}, function(err, access_token) {
        if (err) { console.log(err); return; }

        for (var i = 0; i < project_ids.length; i++) {
          (function(idx) {
            var project_id = project_ids[idx];
            var export_params = {
              format: "pdf",
              filename: "file.pdf",
              destination: "email",
              destination_info: {
                email_address: "production@atomicdisc.com",
                filename: "file.pdf",
                title: project_titles[project_id]
              }
            };
            startExport(access_token, project_id, export_params, function(ierr, job_id) {
              if (ierr) { console.log(ierr); return; }
              setAsPending(access_token, project_id, function(iierr) {
                if (iierr) console.log(iierr);
              });
            });
          })(i);
        }
      });
    });
  };

} // end proofsLoad()


// ── Decide which mode we're in, then load DesignHuddle lib ──────────────────
if (location.href.indexOf('proofs') === -1) {
  designerLoad();
} else {
  proofsLoad();
}

// Dynamically load the DesignHuddle library (no jQuery needed)
var dshdScript = document.createElement('script');
dshdScript.src = 'https://cdn.designhuddle.com/editor/v1/lib.js';
dshdScript.onload = function() {
  DSHDEditorLib.configure({
    domain: "atomicdisc.designhuddle.com",
    guest: true,
    client_id: "3qax6306q59vdglhhafx"
  });
  dshd_runit();
};
document.head.appendChild(dshdScript);